<template>
    <div class="job-results">
      <div class="result-item-wrapper" v-for="(job, index) in jobs" :key="index">
        <div class="result-item mobile-view">
  
          <div class="job-info">
            <div class="job-image-title" @click="showDetail(job.id)">
              <div class="image_wrapper" data-testid="directions-64" @click="userInfoModalOpen(job.jobPharmacy)">
                <el-avatar :size="'small'" shape="square" :src="job.image" v-if="job.image" />
                <el-avatar :size="'small'" class="avatar-job" shape="square"
                  icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
              </div>
              <div class="job-detail-main">
                <div class="job-title">{{ job.title }}</div>
                <div class="job-poster">{{ job.poster }}</div>
              </div>
            </div>
       
          </div>
          <div class="job-detail-more" @click="showDetail(job.id)">
            <el-tag class="inverted">
              {{ job.type }}
            </el-tag>
            <el-tag class="inverted" v-if="!job.hideSalary">
              {{ job.payInterval }} Rate: <span class="blur-price"><strong>{{ job.payRate }}</strong></span>
            </el-tag>
            <el-tag class="inverted">
              Published {{ job.published }}
            </el-tag>
          </div>
          <div class="job-detail-row-item" @click="showDetail(job.id)">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
              <path
                d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
            </svg>
            <div class="job-detail-text blur-price">
              {{ job.location }}
            </div>
          </div>
          <div class="job-detail-row-item" @click="showDetail(job.id)" v-if="job?.jobPharmacy?.software">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.6666 18.3333H13.3333C16.6833 18.3333 17.2833 16.9917 17.4583 15.3583L18.0833 8.69167C18.3083 6.65833 17.7249 5 14.1666 5H5.83327C2.27494 5 1.6916 6.65833 1.9166 8.69167L2.5416 15.3583C2.7166 16.9917 3.3166 18.3333 6.6666 18.3333Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M6.66675 4.99984V4.33317C6.66675 2.85817 6.66675 1.6665 9.33341 1.6665H10.6667C13.3334 1.6665 13.3334 2.85817 13.3334 4.33317V4.99984"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M11.6666 10.8333V11.6667C11.6666 11.675 11.6666 11.675 11.6666 11.6833C11.6666 12.5917 11.6583 13.3333 9.99992 13.3333C8.34992 13.3333 8.33325 12.6 8.33325 11.6917V10.8333C8.33325 10 8.33325 10 9.16659 10H10.8333C11.6666 10 11.6666 10 11.6666 10.8333Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M18.0417 9.1665C16.1167 10.5665 13.9167 11.3998 11.6667 11.6832" stroke="rgb(var(--locumate-primary-color))"
                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M2.18335 9.3916C4.05835 10.6749 6.17502 11.4499 8.33335 11.6916" stroke="rgb(var(--locumate-primary-color))"
                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="job-detail-text">
              {{ job.jobPharmacy.software
            }}<span v-if="job.jobPharmacy.software === 'Other'"
              >: {{ job.jobPharmacy.softwareOther }}</span
            >
            </div>
          </div>
        </div>
  
        <div class="result-item desktop-view" >
  
          <div class="job-info">
            <div class="job-image-title">
              <div class="image_wrapper" data-testid="directions-64" @click="userInfoModalOpen(job.jobPharmacy)">
                <el-avatar :size="'small'" shape="square" :src="job.image" v-if="job.image" />
                <el-avatar :size="'small'" class="avatar-job" shape="square"
                  icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
              </div>
              <div class="job-detail-main">
                <div class="job-title">{{ job.title }}</div>
                <div class="job-poster">{{ job.poster }}</div>
              </div>
            </div>
            <div class="job-option-links">
              
            </div>
          </div>
          <div class="job-detail-more">
            <el-tag class="inverted blur-price">
              {{ job.type }}
            </el-tag>
            <el-tag class="inverted" v-if="!job.hideSalary">
              {{ job.payInterval }} Rate: <span class="blur-price"><strong>{{ job.payRate }}</strong></span>
            </el-tag>
            <el-tag class="inverted">
              Published {{ job.published }}
            </el-tag>
          </div>
          <div class="job-detail-row-item">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
              <path
                d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
            </svg>
            <div class="job-detail-text blur-price">
              {{ job.location }}
            </div>
          </div>
          <div class="job-detail-row-item" v-if="job?.jobPharmacy?.software">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.6666 18.3333H13.3333C16.6833 18.3333 17.2833 16.9917 17.4583 15.3583L18.0833 8.69167C18.3083 6.65833 17.7249 5 14.1666 5H5.83327C2.27494 5 1.6916 6.65833 1.9166 8.69167L2.5416 15.3583C2.7166 16.9917 3.3166 18.3333 6.6666 18.3333Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M6.66675 4.99984V4.33317C6.66675 2.85817 6.66675 1.6665 9.33341 1.6665H10.6667C13.3334 1.6665 13.3334 2.85817 13.3334 4.33317V4.99984"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M11.6666 10.8333V11.6667C11.6666 11.675 11.6666 11.675 11.6666 11.6833C11.6666 12.5917 11.6583 13.3333 9.99992 13.3333C8.34992 13.3333 8.33325 12.6 8.33325 11.6917V10.8333C8.33325 10 8.33325 10 9.16659 10H10.8333C11.6666 10 11.6666 10 11.6666 10.8333Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M18.0417 9.1665C16.1167 10.5665 13.9167 11.3998 11.6667 11.6832" stroke="rgb(var(--locumate-primary-color))"
                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M2.18335 9.3916C4.05835 10.6749 6.17502 11.4499 8.33335 11.6916" stroke="rgb(var(--locumate-primary-color))"
                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="job-detail-text">
              {{ job.jobPharmacy.software
            }}<span v-if="job.jobPharmacy.software === 'Other'"
              >: {{ job.jobPharmacy.softwareOther }}</span
            >
            </div>
          </div>
          <el-button class="text-only desktop-view" @click="showDetail(job.id)">
            View Detail
          </el-button>
        </div>
        <div class="actions" v-show="showActions[index]">
        </div>
      </div>
    </div>
    <modal-user-info :modalName="'userInfoModal'" :options="userInfoModal"></modal-user-info>
  
    
  
  </template>
  
  <script>
  import { inject, ref, reactive, computed, onBeforeMount, onMounted } from "vue";
  import { useRouter } from "vue-router";
  import { PharmacyInfoModal } from "@/modals/modals";
  import { useStore } from "vuex";
  import { trackEvent } from '@/helpers/analytics/ga.js';
  import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
  import { useVuelidate } from '@vuelidate/core';
  import { required, maxLength, helpers } from '@vuelidate/validators';
  export default {
  
    props: {
      jobs: {
        type: Array,
        required: true,
      },
    },
    components: {
      "modal-user-info": PharmacyInfoModal,
    },
  
  
    setup(props, { emit }) {
      const $store = useStore();
      console.log("🚀 ~ setup ~ props:", props)
      const $router = useRouter();
      const $modals = inject("$modals");
      const userData = $store.getters.GET_USER_DATA;
      const modalVisible = ref(false);
      const modalCreateVisible = ref(false);
      const showHeart = ref([]);
      const selectedJobID = ref(null);
      const showActions = ref([]);
      // const userRole = userData.role;
      const userInfoModal = ref({
        name: "userInfo",
        user: {},
      });
  
      const wishLists = ref([
        { title: 'Los Angeles short stay', saved: 2 },
        { title: '2023 Oct Los Angeles, CA, United States', saved: 0 },
        { title: 'morn', saved: 1 },
        { title: 'Waterloo', saved: 0 }
      ]);
  
  
      const form = reactive({
        title: ''
      });
  
      // Vuelidate setup
  
  
      const rules = computed(() => {
        return {
          title: {
            required: helpers.withMessage('Please enter the wishlist name', required),
            maxLength: maxLength(50)
          }
        };
      });
      const v$ = useVuelidate(rules, form);
  
      const validateField = (fieldName) => {
        // Trigger validation for the specified field
        v$.value[fieldName].$touch();
      };

      const isSubmitDisabled = computed(() => {
        return Object.values(form).some(value => value === '') || v$.value.$pending || v$.value.$error;
      });
  
      function getRandomColor(title) {
    // Convert the title to a hash code
    let hash = 0;
    for (let i = 0; i < title.length; i++) {
      hash = title.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    // Generate color based on the hash
    let color = '#';
    for (let i = 0; i < 3; i++) {
      // Adjust the generated color to be within the light spectrum
      let value = (hash >> (i * 8)) & 0xFF;
      // Ensure the value is in the range of light colors and not too close to white
      value = 180 + (value % 56); // 180 to 235 range
      color += ('00' + value.toString(16)).slice(-2);
    }
    
    // Ensure the color is not pure white
    if (color.toUpperCase() === '#FFFFFF') {
      return '#FAFAFA'; // Return a very light gray instead of white
    }
  
    return color;
  }
  
      const clearInput = () => {
        form.title = '';
      }
     
      const userInfoModalOpen = (user) => {
        if (user) {
          userInfoModal.value.user = user;
        }
        $modals.open("userInfoModal");
      };
  
      const showDetail = (jobId) => {
        const job = props.jobs.find(j => j.id === jobId);
        trackEvent('job_clicked', { job_id: jobId, job_title: job?.title, user_type: 'guest' });
        $router.push({
          name: "job-listing-guest-job-detail",
          params: { jobId: jobId }
        });
      };
  
      const openWishlistModal = (job) => {
        console.log("🚀 ~ openWishlistModal ~ job:", job)
        // Show the modal
        modalVisible.value = true;
      };
      const closeWishlistModal = () => {
        modalVisible.value = false;
      };
  
      const createNewWishlist = () => {
        modalCreateVisible.value = true
      }
  
      const closeCreateWishlistModal = () => {
        form.title = '';
  
        modalCreateVisible.value = false;
        v$.value['title'].$reset();
      };
  
  
      const goToMap = (pharmacy) => {
  
        // ${encodeURI('https://www.google.com/maps/dir/?api=1&origin=Space+Needle+Seattle+WA&destination=Pike+Place+Market+Seattle+WA&travelmode=transit')}
        // https://www.google.com/maps/search/?api=1&query=
        // window.open(`https://www.google.com/maps/place/${user.value.address.lat},${user.value.address.lng}`)
  
        if (
          navigator.platform.indexOf("iPhone") != -1 ||
          navigator.platform.indexOf("iPod") != -1 ||
          navigator.platform.indexOf("MacIntel") != -1 ||
          navigator.platform.indexOf("iPad") != -1
        ) {
          const originCord = userData.address.lat + "," + userData.address.lng;
  
          const destinationCord =
            pharmacy.address.lat + "," + pharmacy.address.lng;
  
          const origin = userData.address ? `saddr=${originCord}&` : "";
  
          const destination = pharmacy.address ?
            `daddr=${destinationCord}&` :
            "";
  
          window.open(
            `http://maps.apple.com/?${origin}${destination}dirflg=d&t=m`
          );
        }
  
        // window.open(`maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`);
        // window.open(`http://maps.apple.com/?saddr=${userData.address.text}&daddr=${user.value.address.text}&dirflg=d&t=m`);
        else {
          const zoom = `&zoom=16`;
          const origin = userData.address.lat ?
            `&origin=${userData.address.lat},${userData.address.lng}` :
            "";
          const destination = pharmacy.address.lat ?
            `&destination=${pharmacy.address.lat},${pharmacy.address.lng}` :
            "";
          window.open(
            `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`
          );
        }
      };
  
      const goToChat = (pharmacy) => {
        const chatId = pharmacy.id + "." + userData.id;
        $router.push({
          name: "job_seeker_chat_message",
          params: {
            chatId: chatId,
          },
        });
      };
  
  
      const removeJob = async (jobId) => {
  
        try {
          await ElMessageBox.confirm(
            `Are you sure you want to remove this job?<br><p style='color: #F56C6C;'>Please note that this will also remove the job from saved wishlist.</p></br>`,
            "Remove job",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "Remove",
              cancelButtonText: "Cancel",
              confirmButtonClass: "el-button--danger",
              cancelButtonClass: "el-button--grey",
              showClose: false,
            }
          );
  
          await (async () => {
            try {
              const response = await $store.dispatch("REMOVE_JOB_FROM_JOB_SEEKER_LIST", { jobId: jobId, });
  
              if (response.data.success) {
                emit("jobRemoved", jobId);
                ElMessage({
                  type: "success",
                  message: response.data.message,
                });
                showActions.value = Array(props.jobs.length).fill(false);
                const newWishlistFetch = await $store.dispatch("FETECH_SEEKER_WISHLIST");
                wishLists.value = newWishlistFetch.data.data;
              } else {
                ElMessage({
                  type: "success",
                  message: response.data.message,
                });
              }
  
            } catch (error) {
              console.log(error);
            }
          })();
        } catch (error) {
          console.log(error);
        }
  
      }
  
      onBeforeMount(async () => {
      
      });
  
      const onSwipeLeft = (job,index) => {
        console.log("🚀 ~ onSwipeLeft ~ job:", job)
        showActions.value[index] = true;
        // return function (direction, mouseEvent) {
        //   console.log("Swiped item ", index, ": ", job, " in direction ", direction);
        //   console.log("MouseEvent" , mouseEvent);
  
        // };
  };
  
  const onSwipeRight = (job,index) => {
    console.log("🚀 ~ onSwipeRight ~ job:", job)
    showActions.value[index] = false;
  };
  
  
  
  onMounted(() => {
    showActions.value = Array(props.jobs.length).fill(false);
  });
  
  
      return {
        onSwipeLeft,
        onSwipeRight,
        showActions,
        userInfoModal,
        userInfoModalOpen,
        showDetail,
        removeJob,
        goToMap,
        goToChat,
        openWishlistModal,
        closeWishlistModal,
        modalVisible,
        modalCreateVisible,
        createNewWishlist,
        closeCreateWishlistModal,
        wishLists,
        getRandomColor,
        showHeart,
        form,
        v$,
        validateField,
        isSubmitDisabled,
        clearInput,
        selectedJobID
      };
    },
  };
  </script>
  
  <style scoped>
  /* Component-specific styles go here */
  /* span {
    cursor: pointer;
    color: red;
  } */
  
  
  </style>
  